export default __webpack_public_path__ + "static/media/leave-message.13fbf6fb.png";